import { Instance, types } from 'mobx-state-tree';

export const SubCategoryModel = types.model('SubCategoryModel', {
  id: types.identifier,
  name: types.string,
  category_id: types.string,
});

export type SubCategoryModelType = Instance<typeof SubCategoryModel>;
